export const sortKeys = {
  sortOrder: 'sortOrder',
  dateModified: 'dateModified',
  shared: 'shareWithAll',
};
